import { Capacitor } from '@capacitor/core'

import openSocket from 'socket.io-client'
import { renewToken } from 'store/actions/auth'
import { connectEvents, disconnectEvents } from 'store/middleware/events'
import MockedSocket from 'socket.io-mock'

let RT_URL = ''
if (process.env.REACT_APP_RT_ENDPOINT) RT_URL = process.env.REACT_APP_RT_ENDPOINT
else if (window.location.hostname === 'staging.merinio.com') RT_URL = 'https://staging.merinio.com'
else if (process.env.NODE_ENV === 'production') RT_URL = 'https://rt.merinio.com'
else RT_URL = `http://${window.location.hostname}:3001`

// Keeps the socket in memory to prevent multiple connections
let socket = null

// Function to return the socket if it already exists and create a connection if it doesn't
export function getSocket() {
  // If sockets exists, return it
  if (window.Cypress) return new MockedSocket()
  if (socket) return socket

  let config = {
    query: `token=${localStorage.getItem('token')}&version=${process.env.REACT_APP_CURRENT_VERSION}&portal=true&mobileApp=${Capacitor.isNativePlatform()}`
  }

  // If on mobile, use only websockets, no more need for sticky sessions
  if (Capacitor.isNativePlatform()) config.transports = ['websocket']

  socket = openSocket(RT_URL, config)
  return socket
}

export const connectRealtime = store => next => action => {
  switch (action.type) {
    case 'SET_LOGGED_IN': {
      socket = getSocket()

      // Functions to update the footer CSS
      const rtConnected = () => store.dispatch({ type: 'REALTIME_STATUS', realtimeClass: '' })
      const rtDisconnected = () => store.dispatch({ type: 'REALTIME_STATUS', realtimeClass: 'text-danger' })
      const rtReconnecting = () => store.dispatch({ type: 'REALTIME_STATUS', realtimeClass: 'text-warning' })
      // Trigger token renewal
      const rtRenewToken = () => renewToken(store)

      // Listen on the realtime connection status
      socket.on('connect', rtConnected)
      socket.on('disconnect', rtDisconnected)
      socket.on('reconnecting', rtReconnecting)
      // Watch for permissions update and trigger the fetching of a new token
      socket.on('renewToken', rtRenewToken)
      // Watches for new version

      // Connect realtime for schedule events
      connectEvents(store, socket)

      break
    }
    case 'SET_LOGGED_OUT': {
      socket.off('connect')
      socket.off('disconnect')
      socket.off('reconnecting')
      socket.off('renewToken')

      // Disconnect realtime for schedule events
      disconnectEvents(socket)
      break
    }
    default:
      break
  }

  return next(action)
}

// Function to send a message into the realtime. Commented out since we do not yet use this in the realtime
// For future us
// export function sendSocketMessage(message) {
//   return {
//     type: 'SEND_WEBSOCKET_MESSAGE',
//     payload: message
//   }
// }
